import { format, parse, isBefore, isAfter } from 'date-fns'
import { InvestmentHolidays, InvestmentHours } from 'store/investments/types'

export const isWithinInvestmentHours = (
  holidays: InvestmentHolidays[] = [],
  investmentHours?: InvestmentHours,
  actionType: 'subscription' | 'rescue' = 'subscription'
): boolean => {
  const currentDate = new Date()
  const buenosAiresTime = new Date(currentDate.toLocaleString('en-US', { timeZone: 'America/Argentina/Buenos_Aires' }))
  const currentDay = buenosAiresTime.getDay()

  const todaySlash = format(buenosAiresTime, 'yyyy/MM/dd')
  const todayDash = format(buenosAiresTime, 'yyyy-MM-dd')
  const isHoliday = holidays.some(holiday =>
    holiday.day === todaySlash || holiday.day === todayDash
  )

  const currentTimeStr = format(buenosAiresTime, 'HH:mm')

  const subscriptionHours = investmentHours?.subscription
  const rescueHours = investmentHours?.rescue

  const [startStr, endStr] = actionType === 'subscription'
    ? subscriptionHours || []
    : rescueHours || []

  const startTime = startStr ? parse(startStr, 'H:mm', buenosAiresTime) : null
  const endTime = endStr ? parse(endStr, 'H:mm', buenosAiresTime) : null
  const currentTime = parse(currentTimeStr, 'H:mm', buenosAiresTime)

  const isOutsideHours =
    !startTime ||
    !endTime ||
    isBefore(currentTime, startTime) ||
    isAfter(currentTime, endTime)

  const isWeekend = currentDay === 0 || currentDay === 6

  const isOutOfService = isOutsideHours || isHoliday || isWeekend

  return !isOutOfService
}
